import React from 'react';
import OwlCarousel from 'react-owl-carousel';


class Price extends React.Component {
    componentDidMount() {
        setTimeout(function () {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 2000);
    }
    render() {
        // OwlCarousel Option for Prices
        const options = {
            0: {
                items: 1,
                dots: true,
                margin: 5,
            },
            600: {
                items: 1,
                dots: true,
                margin: 0,
            },
            768: {
                items: 2,
                dots: true,
            },
            992: {
                items: 3,
            },
            1000: {
                items: 3
            }
        };

        // Dynamic Price Data Easy to Update
        let data = [
            { title: 'Basic', lable: 'Free for students', price: 'FREE', features: '<li>Fully functional metronome</li><li>Real-time updates from instructors</li><li>access to dropspin library</li><li>-</li><li>-</li>', link: '#' },
            { title: 'Pro', lable: 'For Instructors and small ensembles', price: '$60', features: '<li>Everything from Basic plus:</li><li>Unlimited Score Hosting</li><li>20+ Linked Accounts</li><li>Access to "Special Access" Scores</li><li>priority email support</li>', link: '#' },
            { title: 'Suite', lable: 'For full marching-band programs', price: '$150', features: '<li>Everything from Pro plus:</li><li>100+ Linked Accounts</li><li>Sync to Staff and Student devices</li><li>custom dropspin storefront</li><li>Includes Bluetooth Receiver (300ft range)</li>', link: '#' },
        ];

        // Dynamic Price Data Loop
        let DataList = data.map((val, i) => {
            return (
                <div className="price-item" key={i}>
                    <div className="price-block">
                        <div className="price-type">
                            <h2>{val.title}</h2>
                        </div>
                        <div className="mrp">
                            <h6 className="user-type">{val.lable}</h6>
                            <div className="price-devide"></div>
                            {i == 0 ? <div className="price-year tj-from-statement white">from</div> : <div className="price-year tj-from-statement">from</div>}
                            <h2>{val.price}</h2>
                            {i == 0 ? <h6 className="price-year"></h6> : <h6 className="price-year">per year</h6>}
                            <div className="price-devide"></div>
                        </div>
                        <ul className="price-feature" dangerouslySetInnerHTML={{ __html: val.features }}></ul>
                        <a href={val.link} className="btn btn-custom theme-color" role="button" >Select Plan</a>
                    </div>
                </div>
            );
        });

        return (
            <section id="price" className="price">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <OwlCarousel
                                className="price-carousel owl-carousel owl-theme"
                                loop={true}
                                margin={30}
                                nav={false}
                                dots={false}
                                responsive={options}
                            >
                                {DataList}
                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


export default Price;


// WEBPACK FOOTER //
// ./src/components/price.js